import { render, staticRenderFns } from "./billingInforManage.vue?vue&type=template&id=552aadc8&scoped=true"
import script from "./billingInforManage.vue?vue&type=script&lang=js"
export * from "./billingInforManage.vue?vue&type=script&lang=js"
import style0 from "./billingInforManage.vue?vue&type=style&index=0&id=552aadc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552aadc8",
  null
  
)

export default component.exports